<template>
    <div class="actions-layout">
        <header class="actions-layout__header">
            <router-link :to="{ name: 'index' }" class="actions-layout__logo">
                <svg>
                    <use xlink:href="#picture-logo" />
                </svg>
            </router-link>

            <div class="actions-layout__user-menu">
                <app-user-menu :isOnlyLogoutAvailable="true"></app-user-menu>
            </div>
        </header>

        <main class="actions-layout__content">
            <common-content-spacer height="medium">
                <slot></slot>
            </common-content-spacer>

            <terms-of-use></terms-of-use>
        </main>
    </div>
</template>

<script>
    import { importComponents } from '~/helpers'
    import TermsOfUse from 'components/page-elements/terms-of-use/TermsOfUseFooter'
    import VersionUpdateServiceWorkerMixin from 'mixins/VersionUpdateServiceWorkerMixin'

    export default {
        mixins: [VersionUpdateServiceWorkerMixin],

        components: {
            ...importComponents(require.context('components/layouts/app-layout')),
            TermsOfUse,
        },
    }
</script>
